import styled from "@emotion/styled";
import { fontRobotoCondensed } from "@product/scmp-sdk";

import { AdSlot } from "scmp-app/components/advertisement/ad-slots/ad-slot";
import { AppFooter } from "scmp-app/components/app-footer";
import { Loading } from "scmp-app/components/common/loading";
import { ContentItemLivePrimary } from "scmp-app/components/content/content-item-render/variants/live-primary";

export const StyledContentItemLivePrimary = styled(ContentItemLivePrimary)``;

export const StyledLoading = styled(Loading)`
  margin-block: 48px;
`;

export const StyledAppFooter = styled(AppFooter)`
  margin-block-start: 48px;
`;

export const StyledAdSlot = styled(AdSlot)`
  inline-size: auto;
  margin-block: 12px;
  margin-inline: auto;

  ${props => props.theme.breakpoints.up("homeDesktop")} {
    margin-block: 0;
  }
`;

export const Heading = styled.div`
  margin-block-end: 32px;
  padding-block: 20px;

  color: #001246;
  font-weight: 700;
  font-size: 28px;
  font-family: ${fontRobotoCondensed};
  font-style: normal;
  line-height: 120%;
  text-align: center;
  text-transform: uppercase;
  font-feature-settings:
    "clig" off,
    "liga" off;
  border-block-end: 1px #000000 solid;

  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-end: 48px;
    padding-block: 32px;

    font-size: 40px;
  }
`;

export const AdContainer = styled.div`
  display: flex;
`;

export const Container = styled.div`
  ${props => props.theme.breakpoints.up("homeDesktop")} {
    max-inline-size: 960px;
    margin-inline: auto;
  }

  ${StyledContentItemLivePrimary}:not(:last-child), ${AdContainer}:not(:last-child) {
    margin-block-end: 20px;
    padding-block-end: 20px;
    border-block-end: 1px rgba(0, 0, 0, 0.2) solid;

    ${props => props.theme.breakpoints.up("tablet")} {
      margin-block-end: 24px;
      padding-block-end: 24px;
    }
  }
`;
